import { makeAutoObservable, observable } from 'mobx'
import React from 'react'
import { isIFrame } from 'utils/isIFrame'

export class ServiceWorkerUpdateStore {
  showDialog: boolean = false
  constructor() {
    makeAutoObservable(this, {
      showDialog: observable,
    })
  }
  prompt() {
    if (!isIFrame()) {
      this.showDialog = true
    }
  }
  ignore() {
    this.showDialog = false
  }
}

export const serviceWorkerUpdateStore = new ServiceWorkerUpdateStore()

export const ServiceWorkerUpdateContext = React.createContext<ServiceWorkerUpdateStore | null>(null)

export const ServiceWorkerUpdateProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <ServiceWorkerUpdateContext.Provider value={serviceWorkerUpdateStore}>
      {children}
    </ServiceWorkerUpdateContext.Provider>
  )
}

export const useServiceWorkerUpdate = () => {
  const context = React.useContext(ServiceWorkerUpdateContext)
  if (context == null) {
    throw new Error('useServiceWorkerUpdate must be within ServiceWorkerUpdateContext')
  }

  return context
}
